import { faq } from './type'

const list: faq[] = [
    {
      id: 1,
      code: '#cate02',
      topName: 'テストの提出',
      question: "テストはどうやって提出するのですか？",
      answer: "「テスト提出サイト」からご提出ください。「テスト提出サイト」にログインするためのお手続き（メールアドレス等のご登録）がまだの方は<a style='color:black; text-decoration-line: underline;' href='/tensaku_visiter/regist/51220091'>登録画面</a>から行ってください。<br><br>郵送での提出は受け付けておりませんので、ご了承ください。",
    },
    {
      id: 2,
      code: '#cate02',
      topName: 'テストの提出',
      question: "テストの提出期限はいつまでですか？また、期限が過ぎてしまった場合、添削してもらえないのでしょうか？",
      answer: "提出期限は2022年10月31日（月）23:59です。それ以降のご提出は承れませんので、ご了承ください。",
    },
    {
      id: 3,
      code: '#cate02',
      topName: 'テストの提出',
      question: "テストを提出した後に書き間違いを見つけたのですが、再度、提出し直せますか？",
      answer: "一度ご提出いただいた答案については、提出し直すことはできません。<br>ただし、こちらで答案を確認させていただき、解答が読み取れないなどの理由で再度ご提出をお願いする場合がありますのでご了承ください。",
    },
    {
      id: 4,
      code: '#cate02',
      topName: 'テストの提出',
      question: "登録しようとしたら登録画面に「ご入力いただいた情報は既に登録されています」と出てしまいます。",
      answer: "既に「テスト提出サイト」へのご登録は完了しておりますので、ご登録のメールアドレス宛に、URL、パスワードをお送りしています。<br>登録完了直後に【名探偵コナンゼミ 小学館思考力テスト】ログイン情報のご案内１、ログイン情報のご案内２の件名で、２通お送りしていますのでご確認ください。<br>メールが見つからない場合は、下部の【お問い合わせ】よりご連絡ください。　",
    },
    {
      id: 5,
      code: '#cate02',
      topName: 'テストの提出',
      question: "「テスト提出サイトご登録」から登録しましたが、返信メールが届きません。",
      answer: "迷惑メール防止設定が解除されていない可能性があります。<br>「@conan-zemi.com」からのメールを受信するには、「@conan-zemi.com」のドメイン指定解除設定が必要です。<br>ドメイン指定解除後、再度、<a style='color:black; text-decoration-line: underline;' href='/tensaku_visiter/regist/51220091'>登録画面</a>より、メールアドレス等のご登録をお願いします。<br>それでも返信がない場合は、下部の【お問い合わせ】よりご連絡ください。",
    },
    {
      id: 6,
      code: '#cate02',
      topName: 'テストの提出',
      question: "テストの二次元コードが読み取れません。",
      answer: '二次元コードは表面と裏面で異なります。また、以下の画面が表示された場合は、推奨動作環境か、またはブラウザのカメラの設定をご確認お願いします。<br><br>【推奨動作環境以外でログインした場合】<br><div style="max-width: 300px; margin: 10px 0 0 39px;"><img style="width: 100%" src="/image/cate05_r_01.jpeg" alt=""></div><br>推奨動作環境以外でログインした可能性がございます。お使いのブラウザが推奨動作環境かご確認ください。iPhone/iPadの場合はSafari、Androidの場合はChromeからテスト提出サイトにログインのうえ、再度お試しください。<br><br><br>【カメラの撮影許可がされていない場合】<br><div class="image-05-r" style="max-width: 300px; margin: 10px 0 0 39px;"><img style="width: 100%" src="/image/cate05_r_02.jpeg" alt=""> </div><br>お使いのブラウザのカメラの撮影が権限が許可されていない可能性がございます。お使いのブラウザのカメラの撮影を権限を許可していただき、再度お試しください。<br>',
    },
    {
      id: 7,
      code: '#cate02',
      topName: 'テストの提出',
      question: "テストを提出する手順がよくわかりません。",
      answer: "以下の手順でご提出ください。<dl><dd style='text-indent: -16px;margin-left: 18px;'>①「テスト提出サイト」にログイン。</dd><dd style='text-indent: -16px;margin-left: 18px;'>②「テスト提出と結果」画面の【提出する】を押す。</dd><dd style='text-indent: -16px;margin-left: 18px;'>③テスト提出方法と注意事項を確認の上【テストを提出する】を押す。</dd><dd style='text-indent: -16px;margin-left: 18px;'>④表面の二次元コードを読み取る。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑤表面のテストを撮影する。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑥表面の撮影画像を確認。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑦表面データ確認用の数字を入力。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑧裏面の二次元コードを読み取る。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑨裏面のテストを撮影する。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑩裏面の撮影画像を確認。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑪裏面データ確認用の数字を入力。</dd><dd style='text-indent: -16px;margin-left: 18px;'>⑫同画面下部の【提出する】を押して提出完了。</dd></dl>",
    },
    {
      id: 8,
      code: '#cate03',
      topName: 'テストの返却',
      question: "テストは提出してからどれくらいで返却されますか？またどのように返却されますか？",
      answer: "ご提出いただいてから約2週間で「テスト提出サイト」にアップいたします。<br>添削完了後、ご登録いただいたメールアドレス宛に完了通知メールをお送りしますので、<a style='color:black; text-decoration-line: underline;' href='/tensaku_visiter/sign_in/51220091'>テスト提出サイト</a>ログイン画面よりログインしてご覧ください。",
    },
    {
      id: 9,
      code: '#cate03',
      topName: 'テストの返却',
      question: "添削済みのテストはどこで閲覧できますか？またいつまで見られるのでしょうか？",
      answer: "テスト添削完了後、「テスト提出サイト」のURLが記載された完了通知メールをお送りします。<br>テスト提出時にご登録いただいたメールアドレス・パスワードにてログインいただいた後、「テスト提出と結果」ページで、「添削済みテスト」「答えと解説」「アドバイスシート」を閲覧・保存いただけます。<br>閲覧期限は2023年3月末です。それまでは何度もアクセスしてご確認いただけます。",
    },
    {
      id: 10,
      code: '#cate04',
      topName: 'ログイン情報',
      question: "メールで「テスト提出サイト」のURLが送られてきましたが、パスワードはどこで確認するのでしょうか？",
      answer: "「テスト提出サイト」URLが記載されたメールと同時に、別メールにて【名探偵コナンゼミ 小学館思考力テスト】ログイン情報のご案内２の件名でお送りしていますのでご確認ください。",
    },
    {
      id: 11,
      code: '#cate04',
      topName: 'ログイン情報',
      question: "「テスト提出サイト」からテストの送信が完了したら、パスワードなどが記載されたメールは削除してしまっても大丈夫ですか？",
      answer: "添削済みテストが返却されるまでは削除しないでください。<br>テスト添削完了後、「テスト提出サイト」のURLが記載された完了通知メールをお送りしますが、パスワードにつきましては、ご登録時のみのご送付となり、完了通知メールには記載されません。<br>パスワードがないと、添削済みテストをご覧になることができませんのでご注意ください。",
    },
    {
      id: 12,
      code: '#cate04',
      topName: 'ログイン情報',
      question: "「テスト提出サイト」にログインするためのパスワードがわからなくなってしまった場合、どうすればよいですか？",
      answer: "パスワードは「テスト提出サイト」にご登録いただいたメールアドレス宛に【名探偵コナンゼミ 小学館思考力テスト】ログイン情報のご案内２の件名で、お送りしていますのでご確認ください。もし、こちらのメールを破棄・見当たらない場合は「テスト提出サイトご登録」の際にご登録いただいたお子さま氏名・お電話番号・メールアドレスを下部の【お問い合わせ】よりご連絡ください。<br>その際、テストについて【未提出の状態】か【提出済の状態】かもあわせてご連絡ください。",
    },
  ]

export default list;
